import React, { useEffect, useState } from "react";
import { Avatar } from "primereact/avatar";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./index.css";
import qodexLogoFull from '../../assets/logos/logo_small.png';
import { Tooltip as MatToolTip } from "@mui/material";
import { SquareArrowOutUpRight } from "lucide-react";

const ShowLongMessage = ({ message }) => {
    const hasRelatedTestScenario = message.related_existing_test_scenarios && message.related_existing_test_scenarios.length > 0;

    return (
        <>
            <div key={"longMessage" + message.id} className="flex justify-start p-6">
                <Avatar
                    id={`assistant-${message.id}`}
                    icon={<img src={qodexLogoFull} alt="Qodex AI Assistant" className="object-cover w-full h-full" />}
                    className="mr-3 bg-white text-[var(--text-primary)] shadow-lg"
                    style={{ width: "2.5rem", height: "2.5rem" }}
                    shape="circle"
                />
                <div className="group w-full shadow-xl transition-all duration-200 rounded-md px-2 py-1 bg-[var(--agent-msg-bg)] text-[var(--text-primary)]" style={{ fontSize: "13px !important" }}>
                    <ReactMarkdown children={message.message_content} remarkPlugins={[remarkGfm]} className="markdown-content text-sm m-0 leading-relaxed break-words" />
                </div>
            </div >

            {hasRelatedTestScenario && (
                <div key={"longMessageDummy" + message.id} className="flex justify-start p-6">
                    <Avatar
                        id={`assistant-${message.id}`}
                        icon={<img src={qodexLogoFull} alt="Qodex AI Assistant" className="object-cover w-full h-full" />}
                        className="mr-3 bg-white text-[var(--text-primary)] shadow-lg"
                        style={{ width: "2.5rem", height: "2.5rem" }}
                        shape="circle"
                    />
                    <div className="group w-full shadow-xl transition-all duration-200 rounded-md px-2 py-1 bg-[var(--agent-msg-bg)] text-[var(--text-primary)]" style={{ fontSize: "13px !important" }}>
                        <p>There are {message.related_existing_test_scenarios.length} similar test scenarios already present in the system.</p>
                        <hr className="border-[var(--borderColor)]" />
                        <ol>
                            {message.related_existing_test_scenarios.map((scenario) => (
                                <li key={scenario.id}>
                                    <div className="flex justify-between items-start">
                                        <span className="flex-1">{scenario.title}</span>
                                        <MatToolTip title="Open test scenario">
                                            <a
                                                href={`/test-scenarios/${scenario.id}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="p-1.5"
                                                aria-label="Open test scenario"
                                            >
                                                <SquareArrowOutUpRight size={14} className="text-[var(--text-secondary)]" />
                                            </a>
                                        </MatToolTip>
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>
                </div >
            )}
        </>
    )
}

export default ShowLongMessage;